<template>
  <div class="body-container">
    <div class="refund-router">
      <div :class="[{ 'active': item.index <= tabIndex }, 'refund-router-li']" v-for="(item, i) in tabList" :key="i">
        <div class="refund-router-num">
          <span :class="[{ 'active': item.index == tabIndex }, 'rign-router-num-box']">
            <span class="sigh-router-num-num" v-show="item.index >= tabIndex">{{ i + 1 }}</span>
            <i class="iconfont icon-tongguo" v-show="item.index < tabIndex"></i>
          </span>
          <span class="refund-router-line" v-if="i > 0"></span>
          <span class="refund-router-line next-active" v-if="item.index == tabIndex && item.index != tabList.length"></span>
        </div>
        <div :class="[{ 'active': item.index == tabIndex }, 'refund-router-title']">
          {{ item.name }}
        </div>
      </div>
    </div>
    <!-- 退保信息 -->
    <orderInfo v-if="tabIndex == 1" :detail="detail" @next="nextStep" />
    <!-- 证件上传 -->
    <ocrSign v-if="tabIndex == 2" :detail="detail" @next="nextStep" />
    <!-- 身份认证 -->
    <face v-if="tabIndex == 3" :detail="detail" @next="nextStep" />
    <!-- 退保结果 -->
    <success v-if="tabIndex == 4" />
  </div>
</template>

<script>
import orderInfo from './components/orderInfo';
import face from './components/face';
import ocrSign from './components/ocrSign';
import success from './components/success';
export default {
  components: {
    orderInfo,
    face,
    ocrSign,
    success
  },
  props: {},
  data() {
    return {
      orderNo: '',
      policyNo: '',
      realPolicyNo: '',
      plat: '',
      detail: {},
      tabIndex: 1,
      tabList: [
        { name: '退保信息', index: 1 },
        { name: '证件上传', index: 2 },
        { name: '身份认证', index: 3 },
        { name: '退保结果', index: 4 }
      ]
    };
  },
  created() {
    if(this.$route.query.sign) {
      sessionStorage.refundSign = this.$route.query.sign;
    }
  },
  mounted() {
    this.orderNo = this.$route.query.key;
    this.policyNo = this.$route.query.policyNo;
    this.realPolicyNo = this.$route.query.realPolicyNo;
    this.plat = this.$route.query.plat;
    wtsScreen.start({
      pageName: '申请退保',
      orderNo: this.orderNo
    });
    if (this.$route.query.face == 1) {
      this.tabIndex = 3;
    }else if(sessionStorage.jumpTBxieyi == 1) {
      this.tabIndex = 3;
    }
    this.detailHttp();
  },
  methods: {
    maskSecondChar(str) {
      if (!str || str.length < 2) return str;
      return str[0] + '*' + str.slice(2);
    },
    detailHttp() {
      this.loading = true;
      this.$http({
        type: 'GET',
        hideAlert: true,
        url: `/api/queryOrderDetail`,
        data: {
          orderNo: this.orderNo
        }
      })
        .then(res => {
          this.loading = false;
          const data = res.data;
          data.policyerName = this.maskSecondChar(data.policyerName);
          if (data.insuredersJson) {
            const insureders = JSON.parse(data.insuredersJson);
            data.insureders = insureders.map(item => this.maskSecondChar(item.insurederName)).join('，');
          }
          this.detail = data;
        })
        .catch(e => {
          this.loading = false;
          if (e.httpCode == '40401') {
            //不是自己的订单跳转个人中心
            this.$router.replace('/m/personal/index');
          } else if (e.httpCode && e.msg) {
            this.$notice.alert(e.msg);
          }
        });
    },
    // 下一步
    nextStep() {
      this.tabIndex++;
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>